import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { StorageService } from "./storage.service";
import { GlobalVariableService } from "./globalvariable.service";
import { ConnectedAccountService } from "./connected-account.service";

@Injectable()
export class APIService {

	constructor(
		private http: HttpClient,
		private storageService: StorageService,
		public globalvar: GlobalVariableService,
		private connectedAccountService: ConnectedAccountService
	) {}

	private requireConnectedAccount(callback:(connected_account: any,resolve,reject)=>any) {
		return new Promise<any>((resolve, reject) => {
			this.storageService
				.get("connected_account_id")
				.then(connected_account_id => {
					if (connected_account_id) {
						this.connectedAccountService
							.getConnectedAccount(connected_account_id)
							.then(connected_account => { 
								if (connected_account) {
									callback(connected_account, resolve, reject);
								} else {
									reject();
								}
							})
							.catch(error => { 
								reject(error);
							});
					} else {
						reject();
					}
				})
				.catch(error => {
					console.error(error);
					reject(error);
				});
		});
	}

	public addOrder(data, idempotency_key?) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();

			// TODO: check for all the right data

			/*
            if(data.person_id !== undefined) {
                form_data.append('person_id', data.person_id);
            }
            if(data.date !== undefined) {
                form_data.append('date', data.date);
            }
            if(data.status !== undefined) {
                form_data.append('status', data.status);
            }
            if(data.channel !== undefined) {
                form_data.append('channel', data.channel);
            }
            if(data.payment_status !== undefined) {
                form_data.append('payment_status', data.payment_status);
            }
            if(data.awaiting_payment_method !== undefined) {
                form_data.append('awaiting_payment_method', data.awaiting_payment_method);
            }
            if(data.currency_id !== undefined) {
                form_data.append('currency_id', data.currency_id);
            }
            if(data.register_id !== undefined) {
                form_data.append('register_id', data.register_id);
            }
            if(data.tax_price !== undefined) {
                form_data.append('tax_price', data.tax_price);
            }
            if(data.discount_price !== undefined) {
                form_data.append('discount_price', data.discount_price);
            }
            if(data.tax_rate_4 !== undefined) {
                form_data.append('tax_rate_4', data.tax_rate_4);
            }
            if(data.tax_rate_5 !== undefined) {
                form_data.append('tax_rate_5', data.tax_rate_5);
            }
            if(data.tax_zone_id !== undefined) {
                form_data.append('tax_zone_id', data.tax_zone_id);
            }
            if(data.total_price !== undefined) {
                form_data.append('total_price', data.total_price);
            }
            if(data.pricing_tier_id !== undefined) {
                form_data.append('pricing_tier_id', data.pricing_tier_id);
            }
            if(data.pricing_tier_tax_inclusive !== undefined) {
                form_data.append('pricing_tier_tax_inclusive', data.pricing_tier_tax_inclusive);
            }

            // if(data.note !== undefined) {
            //     form_data.append('note', data.note);
            // }

            // needs for loop?
            if(data.payment_method !== undefined) {
                form_data.append('payment_method', data.payment_method);
            }
            if(data.payment_price !== undefined) {
                form_data.append('payment_price', data.payment_price);
            }
            if(data.payment_date !== undefined) {
                form_data.append('date', data.date);
            }

            // needs for loop?
            if(data.item_id !== undefined) {
                form_data.append('item_id', data.item_id);
            }
            if(data.item_title !== undefined) {
                form_data.append('item_title', data.item_title);
            }
            if(data.item_quantity !== undefined) {
                form_data.append('item_quantity', data.item_quantity);
            }
            if(data.item_sell_price !== undefined) {
                form_data.append('item_sell_price', data.item_sell_price);
            }
            if(data.item_cost_price !== undefined) {
                form_data.append('item_cost_price', data.item_cost_price);
            }
            if(data.item_type !== undefined) {
                form_data.append('item_type', data.item_type);
            }
            if(data.item_sku !== undefined) {
                form_data.append('item_sku', data.item_sku);
            }
            if(data.item_tax_type !== undefined) {
                form_data.append('item_tax_type', data.item_tax_type);
            }
            if(data.item_discount_rate !== undefined) {
                form_data.append('item_discount_rate', data.item_discount_rate);
            }

            */

			for (let key of Object.keys(data)) {
				form_data.append(key, data[key]);
			}

            let headers = {};
            if(idempotency_key) {
                headers['idempotency-key'] = idempotency_key
            }

			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
                headers: headers
			};

			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
            
		});
	}

	public addOrderComment(order_id, comment) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			form_data.append("comment", comment);
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/comments", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			)
		});
	}

    public addOrderFulfillment(order_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
            for(let i = 0; i < data.items.length; i++){
                let item = data.items[i];
                form_data.append(`item_${i+1}_id`,item.id);
                form_data.append(`item_${i+1}_quantity`,item.quantity);
            }
            if(data.date && data.date.length) {
                form_data.append('date', data.date);
            }
            if(data.courier_id && data.courier_id.length) {
                form_data.append('courier_id', data.courier_id);
            }
            if(data.courier_tracking_number && data.courier_tracking_number.length) {
                form_data.append('courier_tracking_number', data.courier_tracking_number);
            }
            if(data.customer_note && data.customer_note.length) {
                form_data.append('customer_note', data.customer_note);
            }
            if(data.send_order_shipped_email != undefined) {
                form_data.append('send_order_shipped_email', data.send_order_shipped_email);
            }
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/fulfillments", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public addOrderPayment(order_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.method != undefined) {
				form_data.append("method", data.method);
			}
			if(data.date != undefined) {
				form_data.append("date", data.date);
			}
			if(data.price != undefined) {
				form_data.append("price", data.price);
			}
            if(data.surcharge_rate != undefined) {
                form_data.append("surcharge_rate", data.surcharge_rate);
            }
			if(data.send_order_payment_receipt_email != undefined) {
				form_data.append("send_order_payment_receipt_email", data.send_order_payment_receipt_email);
			}
			if(data.add_xero_invoice_payment != undefined) {
				form_data.append("add_xero_invoice_payment", data.add_xero_invoice_payment);
			}
            if(data.payment_service_transaction_id != undefined) {
				form_data.append("payment_service_transaction_id", data.payment_service_transaction_id);
			}
            if(data.payment_service_receipt_text != undefined) {
				form_data.append("payment_service_receipt_text", data.payment_service_receipt_text);
			}
            if(data.payment_service_id != undefined) {
				form_data.append("payment_service_id", data.payment_service_id);
			}
            if(data.gift_voucher_id != undefined) {
				form_data.append("gift_voucher_id", data.gift_voucher_id);
			}
			const options = {
				params: {
					access_token: connected_account['access_token'],
				},
			};
			this.http.post("https://" + connected_account['site_name'] + ".airsquare.com/api/1.0/orders/" + order_id + "/payments", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public addOrderReturn(order_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
            for(let i = 0; i < data.items.length; i++){
                let item = data.items[i];
                form_data.append(`item_${i+1}_id`,item.id);
                form_data.append(`item_${i+1}_quantity`,item.quantity);
            }
            if(data.date && data.date.length) {
                form_data.append('date', data.date);
            }
            if(data.reason && data.reason.length) {
                form_data.append('reason', data.reason);
            }
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/returns", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public addOrderRefund(order_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
            for(let i = 0; i < data.items.length; i++){
                let item = data.items[i];
                form_data.append(`item_${i+1}_id`,item.id);
                form_data.append(`item_${i+1}_quantity`,item.quantity);
            }
            if(data.date && data.date.length) {
                form_data.append('date', data.date);
            }
            if(data.reason && data.reason.length) {
                form_data.append('reason', data.reason);
            }
            if(data.add_xero_credit_note != undefined) {
                form_data.append('add_xero_credit_note', data.add_xero_credit_note);
            }
            if(data.item_shipping != undefined) {
                form_data.append('item_shipping', data.item_shipping);
            }
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/refunds", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    addOrderRefundPayment(order_id, refund_id, data) {

		return this.requireConnectedAccount((connected_account, resolve, reject) => {

			let form_data = new FormData();

            if(data.method != undefined) {
                form_data.append('method', data.method);
            }

            if(data.date != undefined) {
                form_data.append('date', data.date);
            }

            if(data.price != undefined) {
                form_data.append('price', data.price);
            }

            if(data.add_xero_credit_note_payment != undefined) {
                form_data.append('add_xero_credit_note_payment', data.add_xero_credit_note_payment);
            }

            if(data.originating_payment_id != undefined) {
                form_data.append('originating_payment_id', data.originating_payment_id);
            }

            if(data.payment_service_transaction_id != undefined) {
				form_data.append("payment_service_transaction_id", data.payment_service_transaction_id);
			}

            if(data.payment_service_receipt_text != undefined) {
				form_data.append("payment_service_receipt_text", data.payment_service_receipt_text);
			}

            if(data.payment_service_id != undefined) {
				form_data.append("payment_service_id", data.payment_service_id);
			}

            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};

			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + '/refunds/' + refund_id + "/payments", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);

		});
	}

	public addOrganisation(data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if (data.title !== undefined) {
				form_data.append("title", data.title);
			}
			if (data.allow_on_account_payment_method !== undefined) {
				form_data.append("allow_on_account_payment_method", data.allow_on_account_payment_method);
			}
			if (data.pricing_tier_id !== undefined) {
				form_data.append("pricing_tier_id", data.pricing_tier_id);
			}
			if (data.mailing_address_line_1 !== undefined && data.mailing_address_line_1.length) {
				form_data.append("mailing_address_line_1", data.mailing_address_line_1);
			}
			if (data.mailing_address_line_2 !== undefined && data.mailing_address_line_2.length) {
				form_data.append("mailing_address_line_2", data.mailing_address_line_2);
			}
			if (data.mailing_address_locality !== undefined && data.mailing_address_locality.length) {
				form_data.append("mailing_address_locality", data.mailing_address_locality);
			}
			if (data.mailing_address_subdivision !== undefined && data.mailing_address_subdivision.length) {
				form_data.append("mailing_address_subdivision", data.mailing_address_subdivision);
			}
			if (data.mailing_address_postal_code !== undefined && data.mailing_address_postal_code.length) {
				form_data.append("mailing_address_postal_code", data.mailing_address_postal_code);
			}
			if (data.mailing_address_country_id !== undefined && data.mailing_address_country_id.length) {
				form_data.append("mailing_address_country_id", data.mailing_address_country_id);
			}
			if (data.billing_address_line_1 !== undefined && data.billing_address_line_1.length) {
				form_data.append("billing_address_line_1", data.billing_address_line_1);
			}
			if (data.billing_address_line_2 !== undefined && data.billing_address_line_2.length) {
				form_data.append("billing_address_line_2", data.billing_address_line_2);
			}
			if (data.billing_address_locality !== undefined && data.billing_address_locality.length) {
				form_data.append("billing_address_locality", data.billing_address_locality);
			}
			if (data.billing_address_subdivision !== undefined && data.billing_address_subdivision.length) {
				form_data.append("billing_address_subdivision", data.billing_address_subdivision);
			}
			if (data.billing_address_postal_code !== undefined && data.billing_address_postal_code.length) {
				form_data.append("billing_address_postal_code", data.billing_address_postal_code);
			}
			if (data.billing_address_country_id !== undefined && data.billing_address_country_id.length) {
				form_data.append("billing_address_country_id", data.billing_address_country_id);
			}
            if (data.internal_note !== undefined && data.internal_note.length) {
				form_data.append("internal_note", data.internal_note);
			}
			if (data.website_status !== undefined && data.website_status.length) {
				form_data.append("website_status", data.website_status);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public addOrganisationComment(organisation_id, comment) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			form_data.append("comment", comment);
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/comments", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public addOrganisationShippingAddress(organisation_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.first_name !== undefined && data.first_name.length) {
				form_data.append("first_name", data.first_name);
			}
			if(data.last_name !== undefined && data.last_name.length) {
				form_data.append("last_name", data.last_name);
			}
			if(data.organisation_title !== undefined && data.organisation_title.length) {
				form_data.append("organisation_title", data.organisation_title);
			}
            if(data.line_1 !== undefined && data.line_1.length) {
				form_data.append("line_1", data.line_1);
			}
            if(data.line_2 !== undefined && data.line_2.length) {
				form_data.append("line_2", data.line_2);
			}
            if(data.locality !== undefined && data.locality.length) {
				form_data.append("locality", data.locality);
			}
            if(data.subdivision !== undefined && data.subdivision.length) {
				form_data.append("subdivision", data.subdivision);
			}
            if(data.postal_code !== undefined && data.postal_code.length) {
				form_data.append("postal_code", data.postal_code);
			}
            if(data.country_id !== undefined && data.country_id.length) {
				form_data.append("country_id", data.country_id);
			}
            if(data.courier_instructions !== undefined && data.courier_instructions.length) {
				form_data.append("courier_instructions", data.courier_instructions);
			}
            if(data.mobile_phone_number !== undefined && data.mobile_phone_number.length) {
				form_data.append("mobile_phone_number", data.mobile_phone_number);
			}
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/shipping-addresses", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public addPerson(data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if (data.first_name !== undefined && data.first_name.length) {
				form_data.append("first_name", data.first_name);
			}
			if (data.last_name !== undefined && data.last_name.length) {
				form_data.append("last_name", data.last_name);
			}
            if (data.job_title !== undefined && data.job_title.length) {
				form_data.append("job_title", data.job_title);
			}
			if (data.email_address !== undefined && data.email_address.length) {
				form_data.append("email_address", data.email_address);
			}
			if (data.create_username == true) {
				form_data.append("create_username", data.create_username);
				form_data.append("send_choose_password_email", data.create_username);
			}
			if (data.pricing_tier_id !== undefined) {
				form_data.append("pricing_tier_id", data.pricing_tier_id);
			}
			if (data.allow_on_account_payment_method !== undefined) {
				form_data.append("allow_on_account_payment_method", data.allow_on_account_payment_method);
			}
			if (data.email_list_ids !== undefined && data.email_list_ids.length) {
				form_data.append("email_list_ids", data.email_list_ids);
			}
			if (data.mobile_phone_number !== undefined && data.mobile_phone_number.length) {
				form_data.append("mobile_phone_number", data.mobile_phone_number);
			}
			if (data.home_phone_number !== undefined && data.home_phone_number.length) {
				form_data.append("home_phone_number", data.home_phone_number);
			}
			if (data.work_phone_number !== undefined && data.work_phone_number.length) {
				form_data.append("work_phone_number", data.work_phone_number);
			}
			if (data.mailing_address_line_1 !== undefined && data.mailing_address_line_1.length) {
				form_data.append("mailing_address_line_1", data.mailing_address_line_1);
			}
			if (data.mailing_address_line_2 !== undefined && data.mailing_address_line_2.length) {
				form_data.append("mailing_address_line_2", data.mailing_address_line_2);
			}
			if (data.mailing_address_locality !== undefined && data.mailing_address_locality.length) {
				form_data.append("mailing_address_locality", data.mailing_address_locality);
			}
			if (data.mailing_address_subdivision !== undefined && data.mailing_address_subdivision.length) {
				form_data.append("mailing_address_subdivision", data.mailing_address_subdivision);
			}
			if (data.mailing_address_postal_code !== undefined && data.mailing_address_postal_code.length) {
				form_data.append("mailing_address_postal_code", data.mailing_address_postal_code);
			}
			if (data.mailing_address_country_id !== undefined && data.mailing_address_country_id.length) {
				form_data.append("mailing_address_country_id", data.mailing_address_country_id);
			}
			if (data.billing_address_line_1 !== undefined && data.billing_address_line_1.length) {
				form_data.append("billing_address_line_1", data.billing_address_line_1);
			}
			if (data.billing_address_line_2 !== undefined && data.billing_address_line_2.length) {
				form_data.append("billing_address_line_2", data.billing_address_line_2);
			}
			if (data.billing_address_locality !== undefined && data.billing_address_locality.length) {
				form_data.append("billing_address_locality", data.billing_address_locality);
			}
			if (data.billing_address_subdivision !== undefined && data.billing_address_subdivision.length) {
				form_data.append("billing_address_subdivision", data.billing_address_subdivision);
			}
			if (data.billing_address_postal_code !== undefined && data.billing_address_postal_code.length) {
				form_data.append("billing_address_postal_code", data.billing_address_postal_code);
			}
			if (data.billing_address_country_id !== undefined && data.billing_address_country_id.length) {
				form_data.append("billing_address_country_id", data.billing_address_country_id);
			}
			if (data.organisation_id !== undefined && data.organisation_id.length) {
				form_data.append("organisation_id", data.organisation_id);
			}
            if (data.internal_note !== undefined && data.internal_note.length) {
				form_data.append("internal_note", data.internal_note);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public addPersonComment(person_id, comment) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			form_data.append("comment", comment);
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + "/comments", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public addPersonShippingAddress(person_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.first_name !== undefined && data.first_name.length) {
				form_data.append("first_name", data.first_name);
			}
			if(data.last_name !== undefined && data.last_name.length) {
				form_data.append("last_name", data.last_name);
			}
			if(data.organisation_title !== undefined && data.organisation_title.length) {
				form_data.append("organisation_title", data.organisation_title);
			}
            if(data.line_1 !== undefined && data.line_1.length) {
				form_data.append("line_1", data.line_1);
			}
            if(data.line_2 !== undefined && data.line_2.length) {
				form_data.append("line_2", data.line_2);
			}
            if(data.locality !== undefined && data.locality.length) {
				form_data.append("locality", data.locality);
			}
            if(data.subdivision !== undefined && data.subdivision.length) {
				form_data.append("subdivision", data.subdivision);
			}
            if(data.postal_code !== undefined && data.postal_code.length) {
				form_data.append("postal_code", data.postal_code);
			}
            if(data.country_id !== undefined && data.country_id.length) {
				form_data.append("country_id", data.country_id);
			}
            if(data.courier_instructions !== undefined && data.courier_instructions.length) {
				form_data.append("courier_instructions", data.courier_instructions);
			}
            if(data.mobile_phone_number !== undefined && data.mobile_phone_number.length) {
				form_data.append("mobile_phone_number", data.mobile_phone_number);
			}
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + "/shipping-addresses", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public cancelStripePaymentIntent(payment_intent_id){
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				}
			};
			this.http.post("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/stripe/payment-intents/${payment_intent_id}/cancel`,form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

    public createStripePaymentIntent(amount,currency) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
			form_data.append("amount", amount);
			form_data.append("currency", currency);
            const options = {
				params: {
					access_token: connected_account["access_token"],
				}
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/stripe/payment-intents",form_data,options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public createStripeTerminalConnectionToken():Promise<{object:string,secret:string}|{error: any}> {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
            const options = {
				params: {
					access_token: connected_account["access_token"],
				}
            };
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/stripe/terminal/connection-tokens",form_data,options).subscribe(
                (response:string) => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getAccessToken(params) {
		return new Promise((resolve, reject) => {
			let form_data = new FormData();
			form_data.append("grant_type", params.grant_type);
			if (params.code) {
				form_data.append("code", params.code);
			}
			if (params.refresh_token) {
				form_data.append("refresh_token", params.refresh_token);
			}
			form_data.append("client_id", this.globalvar.api_client_id);
			form_data.append("redirect_uri", this.globalvar.api_redirect_uri);
			this.http.post("https://" + params.site_name + ".airsquare.com/api/appauth/pos/token", form_data).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getAffiliate(affiliate_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/affiliates/" + affiliate_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error)
                    reject(error);
                }
            );
		});
	}

    public getAffiliates() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/affiliates", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getCompiledData(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/compiled-data/pos", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getCountries() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/countries", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getCountrySubdivisions(country_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/countries/" + country_id + "/subdivisions", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getCurrentUser(connected_account) {
		return new Promise((resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/users/current", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public getCouriers() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/couriers", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
    }

	public getDonationCampaigns(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/donation-campaigns", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getEmailLists() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/person-email-lists", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    //NOTE: currently unused
	public getEvents(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/events", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getEventCategories(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/event-categories", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getGiftVoucher(gift_voucher_code, params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/gift-vouchers/code:" + gift_voucher_code, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error)
                    reject(error);
                }
            );
		});
	}

	public getGiftVouchers(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/gift-vouchers", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getOrder(order_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {
				access_token: connected_account["access_token"],
			};
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id, { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getOrderByIdempotencyKey(idempotency_key) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {
				access_token: connected_account["access_token"],
			};
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/idempotency-key:" + idempotency_key, { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}    

    public getOrderFulfillment(order_id,fulfillment_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params['access_token'] = connected_account['access_token'];
            this.http.get('https://' + connected_account['site_name'] + '.airsquare.com/api/1.0/orders/' + order_id + '/fulfillments/' + fulfillment_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error)
                    reject(error);
                }
            );
        });
    }

    public getOrderFulfillmentPackingSlip(order_id, fulfillment_id, format) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params['access_token'] = connected_account['access_token'];
            params['format'] = format;
            this.http.get(`https://${connected_account['site_name']}.airsquare.com/api/1.0/orders/${order_id}/fulfillments/${fulfillment_id}/packing-slip`, { params: params, responseType: 'text' }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error)
                    reject(error);
                }
            );
        });
    }

	public getOrderItem(order_id, item_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {
				access_token: connected_account["access_token"],
			};
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/items/" + item_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrderPayment(order_id, payment_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params['access_token'] = connected_account['access_token'];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/payments/" + payment_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrderRefund(order_id, refund_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params['access_token'] = connected_account['access_token'];
            this.http.get('https://' + connected_account['site_name'] + '.airsquare.com/api/1.0/orders/' + order_id + '/refunds/' + refund_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrderRefundPayment(order_id, refund_id, payment_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params['access_token'] = connected_account['access_token'];
            this.http.get('https://' + connected_account['site_name'] + '.airsquare.com/api/1.0/orders/' + order_id + '/refunds/' + refund_id + '/payments/' + payment_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrderReturn(order_id, return_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params['access_token'] = connected_account['access_token'];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/returns/" + return_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrderInvoice(order_id, format, paper_size) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			params["format"] = format;
			params["paper_size"] = paper_size;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/invoice", { responseType: "text",params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    // NOTE: currently unused
    // public getOrderAddressLabel(order_id, format) {
	// 	return this.requireConnectedAccount((connected_account, resolve, reject) => {
	// 		let params = {};
	// 		params["access_token"] = connected_account["access_token"];
    //         params['format'] = format;
	// 		this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/address-label", { responseType: "text",params: params }).subscribe(
    //             response => {
    //                 resolve(response);
    //             },
    //             error => {
    //                 console.error(error);
    //                 reject(error);
    //             }
    //         );
	// 	});
	// }

	public getOrderDeliveryNote(order_id, format) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params['format'] = format;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/delivery-note", { responseType: "text",params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrderCollectionNote(order_id, format) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params['format'] = format;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/collection-note", { responseType: "text",params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrderXeroInvoice(order_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params['format'] = 'pdf_base64';
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/xero-invoice", { responseType: "text",params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrderPackingSlip(order_id, format, items?) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params["access_token"] = connected_account["access_token"];
            params['format'] = format;
            if(items && items.length){
                let form_data = new FormData();
                for(let i = 0; i < items.length; i++){
                    let item = items[i];
                    form_data.append(`item_${i+1}_id`,item.id);
                    form_data.append(`item_${i+1}_quantity`,item.quantity);
                }
                this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/packing-slip", form_data, { params: params, responseType: 'text' }).subscribe(
                    response => {
                        resolve(response);
                    },
                    error => {
                        console.error(error)
                        reject(error);
                    }
                );
            }
            else {
                this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/packing-slip", { params: params, responseType: 'text' }).subscribe(
                    response => {
                        resolve(response);
                    },
                    error => {
                        console.error(error)
                        reject(error);
                    }
                );
            }
		});
	}

	public getOrderTickets(order_id, format, paper_size) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let http_options = {};
            if(format == "html" || format == "pdf_base64") {
				http_options["responseType"] = "text";
			}
            else {
                http_options["responseType"] = "json";
            }
			http_options["params"] = {};
			http_options["params"]["access_token"] = connected_account["access_token"];
			http_options["params"]["format"] = format;
			http_options["params"]["paper_size"] = paper_size;
			http_options["params"]["order_id"] = order_id;
			http_options["params"]["include_person"] = true;
            http_options["params"]["include_person_organisation"] = true;
			http_options["params"]["include_event"] = true;
			http_options["params"]["include_session"] = true;
            http_options["params"]["include_order"] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/event-tickets", http_options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    // currently unused
	public getOrderPersonMemberships(order_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {
				access_token: connected_account["access_token"],
			};
			// this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/items/" , { params: params }).subscribe(
            //     response => {
            //         resolve(response);
            //     },
            //     error => {
            //         console.error(error);
            //         reject(error);
            //     }
            // );
		});
	}

    // currently unused
    public getOrderOrganisationMemberships(order_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {
				access_token: connected_account["access_token"],
			};
			// this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/items/" , { params: params }).subscribe(
            //     response => {
            //         resolve(response);
            //     },
            //     error => {
            //         console.error(error);
            //         reject(error);
            //     }
            // );
		});
	}

    // currently unused
    public getOrderRecurringOrders(order_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {
				access_token: connected_account["access_token"],
			};
			// this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/items/" , { params: params }).subscribe(
            //     response => {
            //         resolve(response);
            //     },
            //     error => {
            //         console.error(error);
            //         reject(error);
            //     }
            // );
		});
	}

	public getOrders(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public getOrderPayments(params) {
        //register_id, from_date, to_date, currency_id
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            params = Object.assign({}, params);
            params['access_token'] = connected_account["access_token"];
            params['format'] = 'json';
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/order-payments", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public getOrderRefundPayments(params) {
        //register_id, from_date, to_date, currency_id
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
            params = Object.assign({}, params);
            params['access_token'] = connected_account["access_token"];
            params['format'] = 'json';
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/order-refund-payments", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getOrganisation(organisation_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params['include_store_credits'] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrganisationContractPrices(organisation_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/contract-prices", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrganisationCreditDetails(organisation_id, currency_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + '/credit-details/' + currency_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrganisationFavourites(organisation_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params["include_item_image"] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/favourites", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrganisationStoreCredit(organisation_id, currency_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + '/store-credits/' + currency_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrganisationTags() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisation-tags" , { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrganisationCategories() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisation-categories", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getOrganisationShippingAddresses(organisation_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/shipping-addresses", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrganisationShippingAddress(organisation_id, shipping_address_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + '/shipping-addresses/' + shipping_address_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

    public getOrganisationMemberships(organisation_id, params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/memberships", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getOrganisations(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getParkedCartQuote(cart, format, paper_size) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
            
			form_data.append("paper_size", paper_size);
			form_data.append("cart_json", JSON.stringify(cart));
			let params = {
				access_token: connected_account["access_token"],
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/parked-cart-quotes/print?format=" + format, form_data, { params: params,responseType: "text" }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getPricingTiers() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/pricing-tiers", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    //NOTE: currently unused
	public getProducts(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/products", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}


	public getProductCategories(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/product-categories", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getPeople(params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getPerson(person_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params['include_store_credits'] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id, { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getPersonCreditDetails(person_id, currency_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + '/credit-details/' + currency_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}


	public getPersonFavourites(person_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params["include_item_image"] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + "/favourites", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getPersonMemberships(person_id, params) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			params = Object.assign({}, params);
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + "/memberships", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getPersonShippingAddresses(person_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + "/shipping-addresses", { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}


    public getPersonShippingAddress(person_id, shipping_address_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + '/shipping-addresses/' + shipping_address_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getPersonStoreCredit(person_id, currency_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + '/store-credits/' + currency_id, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getPersonTags() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/person-tags" , { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getRegister(register_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/registers/"  + register_id, { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    // NOTE: currently unused
	public getRegisters() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/registers", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getLocations() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/locations", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public getStripePaymentIntent(payment_intent_id){
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/stripe/payment-intents/${payment_intent_id}`, { params: params }).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }    

	public getStripeTerminalReaders() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/stripe/terminal/readers", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getSettings(connected_account) {
		return new Promise((resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
            params["flatten"] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/settings", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    // NOTE: currently unused
	public getSupportedCurrencies() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/supported-currencies", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    // NOTE: currently unused
	public getTaxZones() {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/tax-zones", { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public getTicket(ticket_id, format, paper_size) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			params["format"] = format;
			params["paper_size"] = paper_size;
			params["include_event"] = true;
			params["include_session"] = true;
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/event-tickets/" + ticket_id, { responseType: "text",params: params}).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public getUser(user_id) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let params = {};
			params["access_token"] = connected_account["access_token"];
			this.http.get("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/users/"  + user_id, { params: params }).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}    

    public deleteOrganisationShippingAddress(organisation_id, shipping_address_id) {
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params["access_token"] = connected_account["access_token"];
			this.http.delete("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + '/shipping-addresses/' + shipping_address_id, { responseType: "text",params: params}).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
        });
    }

    public deletePersonShippingAddress(person_id, shipping_address_id) {
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let params = {};
            params["access_token"] = connected_account["access_token"];
			this.http.delete("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + '/shipping-addresses/' + shipping_address_id, { responseType: "text",params: params}).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
        });
    }

    public pairSmartpayTerminal(register_id, pairing_code) {
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
            const options = {
				params: {
					access_token: connected_account["access_token"],
                    register_id: register_id,
                    pairing_code: pairing_code
				}
			};
			this.http.post("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/smartpay/pairing`,form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

    public chargeSmartpayTerminal(register_id, amount) {
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
            const options = {
				params: {
					access_token: connected_account["access_token"],
                    amount: amount,
                    register_id: register_id
				}
			};
			this.http.post("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/smartpay/transactions/charges`,form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

    public refundSmartpayTerminal(register_id, amount) {
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
            const options = {
				params: {
					access_token: connected_account["access_token"],
                    amount: amount,
                    register_id: register_id
				}
			};
			this.http.post("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/smartpay/transactions/refunds`,form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

    public getStatusSmartpayTerminal(register_id) {
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            const options = {
				params: {
					access_token: connected_account["access_token"],
                    register_id: register_id
				},
                headers: {
                    'Cache-Control': 'no-cache' // redundant??
                }
			};
			this.http.get("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/smartpay/transactions/status`, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

    public refundStripePaymentIntent(payment_intent_id){
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
			form_data.append("payment_intent_id", payment_intent_id);
            const options = {
				params: {
					access_token: connected_account["access_token"],
				}
			};
			this.http.post("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/stripe/refunds`,form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

	public revokeAccessToken(site_name, access_token) {
		return new Promise((resolve, reject) => {
			if (site_name && access_token) {
				let form_data = new FormData();
				form_data.append("token_type_hint", "access_token");
				form_data.append("token", access_token);
				form_data.append("client_id", this.globalvar.api_client_id);
				this.http.post("https://" + site_name + ".airsquare.com/api/appauth/pos/revoke", form_data).subscribe(
					response => {
						resolve(response);
					},
					error => {
						console.error(error);
						reject(error);
					}
				);
			} else {
				reject();
			}
		});
	}

    public sendOrderConfirmationEmail(order_id, to_email_address) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			if (to_email_address) {
				let form_data = new FormData();
				form_data.append("to_email_address", to_email_address);
				const options = {
					params: {
						access_token: connected_account["access_token"],
					}
				};
				this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + '/actions/send-order-confirmation-email', form_data, options).subscribe(
					response => {
						resolve(response);
					},
					error => {
						console.error(error);
						reject(error);
					}
				);
			} else {
				reject();
			}
		});
	}    

	public sendOrderInvoiceEmail(order_id, to_email_address) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			if (to_email_address) {
				let form_data = new FormData();
				form_data.append("to_email_address", to_email_address);
				const options = {
					params: {
						access_token: connected_account["access_token"],
					}
				};
				this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + '/actions/send-order-invoice-email', form_data, options).subscribe(
					response => {
						resolve(response);
					},
					error => {
						console.error(error);
						reject(error);
					}
				);
			} else {
				reject();
			}
		});
	}

	public sendParkedCartQuoteEmail(cart, to_email_address) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			form_data.append("cart_json", JSON.stringify(cart));
			form_data.append("to_email_address", to_email_address);
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/parked-cart-quotes/email", form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}    

	public updateOrder(order_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
            if (data.person_id != undefined) {
				form_data.append("person_id", data.person_id);
			}
			if (data.organisation_id != undefined) {
				form_data.append("organisation_id", data.organisation_id);
			}
            if (data.affiliate_id != undefined) {
                form_data.append('affiliate_id', data.affiliate_id);
            }
            if (data.purchase_order_number != undefined) {
                form_data.append('purchase_order_number', data.purchase_order_number);
            }
            if (data.reference != undefined) {
                form_data.append('reference', data.reference);
            }
            if (data.archived != undefined) {
                form_data.append('archived', data.archived);
            }
			if (data.shipping_address_first_name != undefined) {
				form_data.append("shipping_address_first_name", data.shipping_address_first_name);
			}
			if (data.shipping_address_last_name != undefined) {
				form_data.append("shipping_address_last_name", data.shipping_address_last_name);
			}
			if (data.shipping_address_organisation_title != undefined) {
				form_data.append("shipping_address_organisation_title", data.shipping_address_organisation_title);
			}
			if (data.shipping_address_line_1 != undefined) {
				form_data.append("shipping_address_line_1", data.shipping_address_line_1);
			}
			if (data.shipping_address_line_2 != undefined) {
				form_data.append("shipping_address_line_2", data.shipping_address_line_2);
			}
			if (data.shipping_address_locality != undefined) {
				form_data.append("shipping_address_locality", data.shipping_address_locality);
			}
			if (data.shipping_address_subdivision != undefined) {
				form_data.append("shipping_address_subdivision", data.shipping_address_subdivision);
			}
			if (data.shipping_address_postal_code != undefined) {
				form_data.append("shipping_address_postal_code", data.shipping_address_postal_code);
			}
			if (data.shipping_address_country_id != undefined) {
				form_data.append("shipping_address_country_id", data.shipping_address_country_id);
			}
            if (data.shipping_address_mobile_phone_number != undefined) {
				form_data.append("shipping_address_mobile_phone_number", data.shipping_address_mobile_phone_number);
			}
			if (data.shipping_address_courier_instructions != undefined) {
				form_data.append("shipping_address_courier_instructions", data.shipping_address_courier_instructions);
			}
            if (data.shipping_notification_email_address != undefined) {
                form_data.append("shipping_notification_email_address", data.shipping_notification_email_address);
            }
			if (data.gift != undefined) {
				form_data.append("gift", data.gift);
			}
			if (data.gift_message != undefined) {
				form_data.append("gift_message", data.gift_message);
			}
			if (data.delivery_date != undefined) {
				form_data.append("delivery_date", data.delivery_date);
			}
            if (data.special_instructions != undefined) {
				form_data.append("special_instructions", data.special_instructions);
			}
			if (data.customer_note != undefined) {
				form_data.append("customer_note", data.customer_note);
			}
			if (data.internal_note != undefined) {
				form_data.append("internal_note", data.internal_note);
			}
            if (data.pickup != undefined) {
				form_data.append("pickup", data.pickup);
			}
            if (data.pickup_date != undefined) {
				form_data.append("pickup_date", data.pickup_date);
			}

			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};

			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id, form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);

		});
	}

	updateOrderFulfillment(order_id, fulfillment_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
            if(data.date != undefined) {
                form_data.append('date', data.date);
            }
            if(data.courier_id != undefined) {
                form_data.append('courier_id', data.courier_id);
            }
            if(data.courier_tracking_number != undefined) {
                form_data.append('courier_tracking_number', data.courier_tracking_number);
            }
            if(data.customer_note != undefined) {
                form_data.append('customer_note', data.customer_note);
            }
            if(data.send_order_shipped_email != undefined) {
                form_data.append('send_order_shipped_email', data.send_order_shipped_email);
            }
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/fulfillments/" + fulfillment_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	updateOrderItem(order_id, item_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if (data.customer_note != undefined) {
				form_data.append("customer_note", data.customer_note);
			}
			if (data.internal_note != undefined) {
				form_data.append("internal_note", data.internal_note);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/items/" + item_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	updateOrderPayment(order_id, payment_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {

			let form_data = new FormData();

			if(data.date != undefined) {
				form_data.append("date", data.date);
			}

            if(data.payment_service_transaction_id != undefined) {
				form_data.append("payment_service_transaction_id", data.payment_service_transaction_id);
			}

            if(data.payment_service_receipt_text != undefined) {
				form_data.append("payment_service_receipt_text", data.payment_service_receipt_text);
			}

			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};

			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/payments/" + payment_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );

		});
	}

	updateOrderRefund(order_id, refund_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if (data.date != undefined) {
				form_data.append("date", data.date);
			}
			if (data.reason != undefined) {
				form_data.append("reason", data.reason);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/refunds/" + refund_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	updateOrderRefundPayment(order_id, refund_id, payment_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {

			let form_data = new FormData();

			if(data.date != undefined) {
				form_data.append("date", data.date);
			}
            if(data.payment_service_transaction_id != undefined) {
				form_data.append("payment_service_transaction_id", data.payment_service_transaction_id);
			}

            if(data.payment_service_receipt_text != undefined) {
				form_data.append("payment_service_receipt_text", data.payment_service_receipt_text);
			}

			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};

			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/refunds/" + refund_id + "/payments/" + payment_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );

		});
	}

	updateOrderReturn(order_id, return_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if (data.date != undefined) {
				form_data.append("date", data.date);
			}
			if (data.reason != undefined) {
				form_data.append("reason", data.reason);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/orders/" + order_id + "/returns/" + return_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public updateOrganisation(organisation_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.title != undefined) {
				form_data.append("title", data.title);
			}
			if(data.allow_on_account_payment_method != undefined) {
				form_data.append("allow_on_account_payment_method", data.allow_on_account_payment_method);
			}
			if(data.pricing_tier_id != undefined) {
				form_data.append("pricing_tier_id", data.pricing_tier_id);
			}
			if(data.mailing_address_line_1 != undefined) {
				form_data.append("mailing_address_line_1", data.mailing_address_line_1);
			}
			if(data.mailing_address_line_2 != undefined) {
				form_data.append("mailing_address_line_2", data.mailing_address_line_2);
			}
			if(data.mailing_address_locality != undefined) {
				form_data.append("mailing_address_locality", data.mailing_address_locality);
			}
			if(data.mailing_address_subdivision != undefined) {
				form_data.append("mailing_address_subdivision", data.mailing_address_subdivision);
			}
			if(data.mailing_address_postal_code != undefined) {
				form_data.append("mailing_address_postal_code", data.mailing_address_postal_code);
			}
			if(data.mailing_address_country_id != undefined) {
				form_data.append("mailing_address_country_id", data.mailing_address_country_id);
			}
			if(data.billing_address_line_1 != undefined) {
				form_data.append("billing_address_line_1", data.billing_address_line_1);
			}
			if(data.billing_address_line_2 != undefined) {
				form_data.append("billing_address_line_2", data.billing_address_line_2);
			}
			if(data.billing_address_locality != undefined) {
				form_data.append("billing_address_locality", data.billing_address_locality);
			}
			if(data.billing_address_subdivision != undefined) {
				form_data.append("billing_address_subdivision", data.billing_address_subdivision);
			}
			if(data.billing_address_postal_code != undefined) {
				form_data.append("billing_address_postal_code", data.billing_address_postal_code);
			}
			if(data.billing_address_country_id != undefined) {
				form_data.append("billing_address_country_id", data.billing_address_country_id);
			}
			if(data.internal_note != undefined) {
				form_data.append("internal_note", data.internal_note);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );

		});
	}

	public updateOrganisationShippingAddress(organisation_id, shipping_address_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.first_name != undefined) {
				form_data.append("first_name", data.first_name);
			}
			if(data.last_name != undefined) {
				form_data.append("last_name", data.last_name);
			}
			if(data.organisation_title != undefined) {
				form_data.append("organisation_title", data.organisation_title);
			}
            if(data.line_1 != undefined) {
				form_data.append("line_1", data.line_1);
			}
            if(data.line_2 != undefined) {
				form_data.append("line_2", data.line_2);
			}
            if(data.locality != undefined) {
				form_data.append("locality", data.locality);
			}
            if(data.subdivision != undefined) {
				form_data.append("subdivision", data.subdivision);
			}
            if(data.postal_code != undefined) {
				form_data.append("postal_code", data.postal_code);
			}
            if(data.country_id != undefined) {
				form_data.append("country_id", data.country_id);
			}
            if(data.courier_instructions != undefined) {
				form_data.append("courier_instructions", data.courier_instructions);
			}
            if(data.mobile_phone_number != undefined) {
				form_data.append("mobile_phone_number", data.mobile_phone_number);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/organisations/" + organisation_id + "/shipping-addresses/" + shipping_address_id, form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

	public updatePerson(person_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.first_name != undefined) {
				form_data.append("first_name", data.first_name);
			}
			if(data.last_name != undefined) {
				form_data.append("last_name", data.last_name);
			}
            if(data.job_title != undefined) {
				form_data.append("job_title", data.job_title);
			}
			if(data.email_address != undefined) {
				form_data.append("email_address", data.email_address);
			}
			if(data.pricing_tier_id != undefined) {
				form_data.append("pricing_tier_id", data.pricing_tier_id);
			}
			if(data.allow_on_account_payment_method != undefined) {
				form_data.append("allow_on_account_payment_method", data.allow_on_account_payment_method);
			}
			if(data.email_list_ids != undefined) {
				form_data.append("email_list_ids", data.email_list_ids);
			}
			if(data.organisation_id != undefined) {
				form_data.append("organisation_id", data.organisation_id);
			}
			if(data.mobile_phone_number != undefined) {
				form_data.append("mobile_phone_number", data.mobile_phone_number);
			}
			if(data.home_phone_number != undefined) {
				form_data.append("home_phone_number", data.home_phone_number);
			}
			if(data.work_phone_number != undefined) {
				form_data.append("work_phone_number", data.work_phone_number);
			}
			if(data.mailing_address_line_1 != undefined) {
				form_data.append("mailing_address_line_1", data.mailing_address_line_1);
			}
			if(data.mailing_address_line_2 != undefined) {
				form_data.append("mailing_address_line_2", data.mailing_address_line_2);
			}
			if(data.mailing_address_locality != undefined) {
				form_data.append("mailing_address_locality", data.mailing_address_locality);
			}
			if(data.mailing_address_subdivision != undefined) {
				form_data.append("mailing_address_subdivision", data.mailing_address_subdivision);
			}
			if(data.mailing_address_postal_code != undefined) {
				form_data.append("mailing_address_postal_code", data.mailing_address_postal_code);
			}
			if(data.mailing_address_country_id != undefined) {
				form_data.append("mailing_address_country_id", data.mailing_address_country_id);
			}
			if(data.billing_address_line_1 != undefined) {
				form_data.append("billing_address_line_1", data.billing_address_line_1);
			}
			if(data.billing_address_line_2 != undefined) {
				form_data.append("billing_address_line_2", data.billing_address_line_2);
			}
			if(data.billing_address_locality != undefined) {
				form_data.append("billing_address_locality", data.billing_address_locality);
			}
			if(data.billing_address_subdivision != undefined) {
				form_data.append("billing_address_subdivision", data.billing_address_subdivision);
			}
			if(data.billing_address_postal_code != undefined) {
				form_data.append("billing_address_postal_code", data.billing_address_postal_code);
			}
			if(data.billing_address_country_id != undefined) {
				form_data.append("billing_address_country_id", data.billing_address_country_id);
			}
			if(data.internal_note != undefined) {
				form_data.append("internal_note", data.internal_note);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}

	public updatePersonShippingAddress(person_id, shipping_address_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.first_name != undefined) {
				form_data.append("first_name", data.first_name);
			}
			if(data.last_name != undefined) {
				form_data.append("last_name", data.last_name);
			}
			if(data.organisation_title != undefined) {
				form_data.append("organisation_title", data.organisation_title);
			}
            if(data.line_1 != undefined) {
				form_data.append("line_1", data.line_1);
			}
            if(data.line_2 != undefined) {
				form_data.append("line_2", data.line_2);
			}
            if(data.locality != undefined) {
				form_data.append("locality", data.locality);
			}
            if(data.subdivision != undefined) {
				form_data.append("subdivision", data.subdivision);
			}
            if(data.postal_code != undefined) {
				form_data.append("postal_code", data.postal_code);
			}
            if(data.country_id != undefined) {
				form_data.append("country_id", data.country_id);
			}
            if(data.courier_instructions != undefined) {
				form_data.append("courier_instructions", data.courier_instructions);
			}
            if(data.mobile_phone_number != undefined) {
				form_data.append("mobile_phone_number", data.mobile_phone_number);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/people/" + person_id + "/shipping-addresses/" + shipping_address_id, form_data, options).subscribe(
				response => {
					resolve(response);
				},
				error => {
					console.error(error);
					reject(error);
				}
			);
		});
	}

    public updateStripePaymentIntent(payment_intent_id,data: any){
        return this.requireConnectedAccount((connected_account, resolve, reject) => {
            let form_data = new FormData();
			form_data.append("description", data.description);
			form_data.append("metadata_order_id", data.order_id);
			form_data.append("metadata_order_number", data.order_number);
            form_data.append("metadata_channel", 'point_of_sale');
            const options = {
				params: {
					access_token: connected_account["access_token"],
				},
                headers: {
					"x-http-method-override": "patch"
				}
            };
			this.http.post("https://" + connected_account["site_name"] + `.airsquare.com/api/1.0/stripe/payment-intents/${payment_intent_id}`,form_data,options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
    }

    public updateUser(user_id, data) {
		return this.requireConnectedAccount((connected_account, resolve, reject) => {
			let form_data = new FormData();
			if(data.pin != undefined) {
				form_data.append("pin", data.pin);
			}
			const options = {
				params: {
					access_token: connected_account["access_token"],
				},
				headers: {
					"x-http-method-override": "patch",
				},
			};
			this.http.post("https://" + connected_account["site_name"] + ".airsquare.com/api/1.0/users/" + user_id, form_data, options).subscribe(
                response => {
                    resolve(response);
                },
                error => {
                    console.error(error);
                    reject(error);
                }
            );
		});
	}    

}
